/** @fileoverview update_user_analytics_url_group の共通定数 */

/** ツール名（単一参照点） */
export const UPDATE_UA_URL_GROUP_NAME =
  "update_user_analytics_url_group" as const;

/** LLM へ提示する説明文 */
export const UPDATE_UA_URL_GROUP_DESC =
  `Updates an existing User Analytics URL Group by ID.

Use this when a user wants to rename a URL group, change its description, logical operator, or patterns.

Input:
- 'id' (required): URL Group ID.
- Optional: 'name', 'description' (string or null to clear), 'op' (AND/OR), 'patterns' [{ type, pattern }].

Notes:
- Write operation; will prompt for confirmation before executing.
- Returns: updated URLGroup { id, name, description, op, patterns }.` as const;
